import { Group, Stack, TextInput } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useAmlFormContext } from '../types/types';

export function RepresentativeStep() {
  const { t } = useTranslation();
  const form = useAmlFormContext();

  return (
    <Stack gap="md" mt="md">
      <Group wrap="nowrap">
        <TextInput
          required
          w="100%"
          label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.LAST_NAME)}
          placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.LAST_NAME)}
          {...form.getInputProps('lastName')}
        />
        <TextInput
          required
          w="100%"
          label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.FIRST_NAME)}
          placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.FIRST_NAME)}
          {...form.getInputProps('firstName')}
        />
      </Group>
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.ADDRESS)}
        placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.ADDRESS)}
        {...form.getInputProps('address')}
      />
      <Group gap="md" wrap="nowrap">
        <TextInput
          required
          w="100%"
          label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.MOBILE)}
          placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.MOBILE)}
          {...form.getInputProps('mobile')}
        />
        <TextInput
          required
          w="100%"
          label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.EMAIL)}
          placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.EMAIL)}
          {...form.getInputProps('email')}
        />
      </Group>
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.REPRESENTATIVE.NATIONAL_NUMBER)}
        placeholder={t(i18nKeys.AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.NATIONAL_NUMBER)}
        {...form.getInputProps('nationalNumber')}
      />
    </Stack>
  );
}
